module.exports = __webpack_public_path__ + "media/images/icon__point--gained@3x-79d97fbb28702cbb6e4b898a0864e419.png";